import { z } from 'zod/v4';
import { CONNECTION_TYPE_VALUES } from './create-company.js';

export const CompanyLinkBodySchema = z.object({
  forCompanyId: z.string().min(1).max(4000),
  connectionType: z.enum(CONNECTION_TYPE_VALUES),
});

export type CompanyLinkBody = z.infer<typeof CompanyLinkBodySchema>;

export const CompanyLinkResponseSchema = z.object({
  id: z.string(),
  connectionType: z.enum(CONNECTION_TYPE_VALUES),
});

export type CompanyLinkResponse = z.infer<typeof CompanyLinkResponseSchema>;
